import React from 'react';
import * as PropTypes from 'prop-types';
import { Tooltip } from 'react-lightweight-tooltip';
import { tooltipStyles } from './styles/LwolfTooltip.css';

const LwolfTooltip = props => {
  return (
    <Tooltip content={props.content} styles={tooltipStyles}>
      {props.children}
    </Tooltip>
  );
};

LwolfTooltip.propTypes = {
  content: PropTypes.string
};

export default LwolfTooltip;
